module.exports = __webpack_public_path__ + "static/media/5.275f9d00.jpg";